module.exports = "<div class=\"form-group typeahead-wrapper\"> <app-widgets-searchbox config=$ctrl.config> <custom-search> <input type=text autocomplete=off class=form-control minlength=1 maxlength=100 name=area-search clear-on-select=true app-widgets-searchbox-input trigger-focus=$parent.$ctrl.isInputFocused placeholder=\"{{ 'Search' | translate }}\" ngeo-search=$parent.$ctrl.options ngeo-search-datasets=$parent.$ctrl.datasets ngeo-search-listeners=$parent.$ctrl.listeners> </custom-search> </app-widgets-searchbox> </div>";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/area/search/partial.html
// module id = 406
// module chunks = 0